export const subscriptionPlanTypes = {
  FREE: 'FREE',
  PRO: 'PRO',
  PLUS: 'PLUS',
  ENTERPRISE: 'ENTERPRISE',
  FREE_TRIAL: 'FREE TRIAL',
  READ_ONLY: 'READ ONLY'
};

export const subscriptionBlockerType = {
  FULL: 'Full',
  PARTIAL: 'Partial'
};
